const FileUploadOutlined = ({ fill = '#fff' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 20 20'>
    <path
      fill={fill}
      d='m17.108 7.058-5-5a.62.62 0 0 0-.441-.183h-5c-2.015 0-3.125 1.11-3.125 3.125v10c0 2.015 1.11 3.125 3.125 3.125h7.5c2.015 0 3.125-1.11 3.125-3.125V7.5a.62.62 0 0 0-.184-.442M12.292 4.01l2.866 2.866h-.991c-1.314 0-1.875-.56-1.875-1.875zm1.875 12.866h-7.5c-1.314 0-1.875-.56-1.875-1.875V5c0-1.314.56-1.875 1.875-1.875h4.375V5c0 2.015 1.11 3.125 3.125 3.125h1.875V15c0 1.314-.561 1.875-1.875 1.875m-2.892-5.65a.625.625 0 0 1-.883.884l-.6-.6v2.658a.625.625 0 0 1-1.25 0v-2.658l-.6.6a.625.625 0 0 1-.884-.884l1.666-1.667a.62.62 0 0 1 .681-.135.6.6 0 0 1 .203.135z'
    />
  </svg>
);

export default FileUploadOutlined;
